import React from 'react'
import { DeleteOutlineSharp } from '@material-ui/icons'
import { MdVerifiedUser } from 'react-icons/md'
import styles from './WorkExperienceCard.module.css'

const WorkExperienceCard = (props) => {
    let item = props.item
    const { editExperienceHandler } = props

    return (
        <div className={styles.mainWrapper}>

            <div className={styles.cardHeader}>
                <div className={styles.headerLeft}>
                    <div className={styles.storeName}>{item.salon_name}</div>
                    <div className={styles.storeAddress}>{item.address}</div>
                </div>
                {item.is_verified === "0" ? (
                    <div className={styles.unverifiedBadge}>
                        <MdVerifiedUser size={12} />
                        <span>Unverified</span>
                    </div>
                ) : (
                    <div className={styles.verifiedBadge}>
                        <MdVerifiedUser size={12} color="#15803d" />
                        <span>Verified</span>
                    </div>
                )}
            </div>

            <div className={styles.profileDetails}>

                <div className={styles.designationRow}>
                    <div className={styles.profileTitle}>{item.designation}</div>
                    <div className={styles.salaryRow}>
                        <span className={styles.salaryAmount}>
                            {item.monthlySalary ? `₹${item.monthlySalary}/mo` : '—'}
                        </span>
                        {item.modeOfSalary ? (
                            <span className={styles.modeOfSalary}>{item.modeOfSalary}</span>
                        ) : null}
                    </div>
                </div>

                {item.event_description ? (
                    <div className={styles.descriptionWrapper}>
                        {item.event_description}
                    </div>
                ) : null}

                {item.reasonOfLeaving ? (
                    <div className={styles.reasonBlock}>
                        <div className={styles.reasonLabel}>Reason of leaving</div>
                        <div className={styles.reasonText}>{item.reasonOfLeaving}</div>
                    </div>
                ) : null}

                <div className={styles.timelineWrapper}>
                    <div className={styles.timelineItem}>
                        <span className={styles.timelineLabel}>From</span>
                        <span className={styles.timelineValue}>
                            {item.start_date ? item.start_date.substr(0, 10) : '—'}
                        </span>
                    </div>
                    <div className={styles.timelineDivider} />
                    <div className={styles.timelineItem}>
                        <span className={styles.timelineLabel}>To</span>
                        <span className={styles.timelineValue}>
                            {item.isCurrentlyWorking === '1' || item.isCurrentlyWorking === true || item.isCurrentlyWorking === 1
                                ? <span className={styles.presentTag}>Present</span>
                                : item.end_date ? item.end_date.substr(0, 10) : '—'
                            }
                        </span>
                    </div>
                </div>

            </div>

            <div className={styles.footerWrapper}>
                <button className={styles.deleteBtn}>
                    <DeleteOutlineSharp style={{ fontSize: 15 }} />
                    <span>Delete</span>
                </button>
                <button className={styles.editBtn} onClick={() => editExperienceHandler(item)}>
                    Edit
                </button>
            </div>

        </div>
    )
}

export default WorkExperienceCard